
var id = "admin";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 612 612\" id=\"admin\">\n<g>\n\t<path d=\"M305.7-0.5C136.9-0.5-0.5,136.9-0.5,305.8C-0.5,474.6,137,612,305.8,612C474.6,612,612,474.6,612,305.8\n\t\tC612,137,474.6-0.5,305.7-0.5L305.7-0.5z M305.7,586.6c-154.9,0-280.8-126-280.8-280.9c0-154.9,126-280.8,280.8-280.8\n\t\tc154.9,0,280.8,126,280.8,280.8C586.6,460.6,460.6,586.6,305.7,586.6L305.7,586.6z M365.4,311c39.3-26.3,56.8-75.2,43.1-120.4\n\t\tc-13.7-45.2-55.4-76.2-102.7-76.2c-47.3,0-89,30.9-102.7,76.2c-13.7,45.3,3.8,94.2,43.1,120.4c-62.3,24.6-103.3,84.8-103.1,151.8\n\t\tv0.1c0,9.4,7.6,17,17,17c9.4,0,13.2-7.6,13.2-17c0-0.2-0.1-0.4-0.1-0.6c0.1-71.1,61.5-132.5,132.6-132.5\n\t\tc71.1,0,132.6,61.5,132.6,132.6c0,0.1-0.9,17.5,13.2,17.5c4.5,0,8.8-1.8,12-4.9c3.2-3.2,5-7.5,5-12l0-0.1v-0.5\n\t\tC468.5,395.5,427.6,335.5,365.4,311L365.4,311z M305.8,302.9c-44.8,0-81.1-36.3-81.1-81.1c0-44.8,36.3-81.1,81.1-81.1\n\t\tc44.8,0,81.1,36.3,81.1,81.1C386.9,266.5,350.6,302.9,305.8,302.9L305.8,302.9z M305.8,302.9\" />\n</g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
